import type { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Formik } from 'formik';
import * as yup from 'yup';
import {
  Box,
  CardContent,
  Divider,
  Link,
  Typography,
  Button,
  TextField,
} from '@material-ui/core';

const Recovery: FC = () => {
  const validation = yup.object({
    email: yup
      .string()
      .email('Debe ingresar el correo electrónico correctamente')
      .required('El correo electrónico es obligatorio'),
  });
  return (
    <>
      <CardContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          p: 4,
        }}
      >
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'space-between',
            mb: 3,
          }}
        >
          <div>
            <Typography color="textPrimary" gutterBottom variant="h4">
              Solicitar el restablecimiento de la contraseña
            </Typography>
          </div>
        </Box>
        <Formik
          validationSchema={validation}
          initialValues={{ email: '' }}
          onSubmit={() => {
            console.log('TODO');
          }}
        >
          {({ handleSubmit, values, touched, errors, handleChange }) => (
            <form onSubmit={handleSubmit}>
              <TextField
                name="email"
                placeholder="Correo electr&oacute;nico"
                value={values.email}
                fullWidth
                onChange={handleChange}
                error={touched.email && Boolean(errors.email)}
                helperText={touched.email && errors.email}
              />
              <Box sx={{ mt: 2 }}>
                <Button
                  color="primary"
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                >
                  Restablecer contrase&ntilde;a
                </Button>
              </Box>
              <Divider sx={{ my: 3 }} />
              <Link
                color="textPrimary"
                component={RouterLink}
                sx={{ mt: 1 }}
                to="/"
                variant="body2"
              >
                Iniciar sesi&oacute;n
              </Link>
            </form>
          )}
        </Formik>
      </CardContent>
    </>
  );
};

export default Recovery;
